import { RoutesList } from '@animal-nuisance/routes/Routes';
import { TextAreaTemplate } from '@templates';
import { ErrorMessages } from '@types';
import {
  parseZodErrors,
  TextAreaIssueSchema,
  TextAreaIssueSchemaType,
} from '@utils';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ZodError } from 'zod';
import { issueInfoQuestionData } from '@animal-nuisance/constants/questionData';
import { useAnimalNuisanceStore } from '@animal-nuisance/hooks/useAnimalNuisanceStore';
import { TEXT_AREA_MAX_LENGTH } from '@constants';

export const DescribeTheIssuePage = () => {
  const {
    update,
    data: { issueInfo, issueTypes },
  } = useAnimalNuisanceStore();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const navigate = useNavigate();

  const { titleMandatory, titleOptional, key, description, errorMessage } =
    issueInfoQuestionData;

  const isSomethingElseIssue = issueTypes?.find(
    (type) => type.name === 'SomethingElse',
  );
  const title = isSomethingElseIssue ? titleMandatory : titleOptional;

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (errorMessages.length > 0) {
      setErrorMessages([]);
    }
    update('issueInfo', event.target.value);
  };

  const handleNextClick = () => {
    let validation = {
      fieldNames: [key],
      maxLength: TEXT_AREA_MAX_LENGTH,
    };

    try {
      if (isSomethingElseIssue || issueInfo) {
        validation = {
          ...validation,
        } as TextAreaIssueSchemaType;
        TextAreaIssueSchema(validation).parse({
          issueInfo,
        });
      }
      navigate(RoutesList.IS_RECURRING_ISSUE);
    } catch (error) {
      const validationErrors = parseZodErrors(error as ZodError);
      setErrorMessages(
        validationErrors.map((error: ErrorMessages) => ({
          ...error,
          message: error.message === 'Required' ? errorMessage : error.message,
        })),
      );
    }
  };

  const handlePreviousClick = () => {
    navigate(RoutesList.ISSUE_TYPE);
  };

  const buttonNext = {
    onClick: handleNextClick,
  };

  const buttonPrevious = {
    onClick: handlePreviousClick,
  };

  return (
    <TextAreaTemplate
      initialTextValue={issueInfo}
      labelText={title}
      description={description}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      maxLength={TEXT_AREA_MAX_LENGTH}
      errorPath={key}
      errorMessages={errorMessages}
    />
  );
};
